import React from 'react';

import Button from '@components/Button';
import IconArrow from '@components/Images/IconArrow';
import { useSubscribeForm } from '@contexts/SubscribeFormContext';
import { SelectedExtendedOffer } from '@utils/backend-api/subscribe';

import PaymentForm from './PaymentForm';
import SelectedSubscription from './SelectedSubscription';

interface CheckoutProps {
  onBackClick: () => void;
  presentedOfferCodes: string[];
  selectedOffer: SelectedExtendedOffer;
}

const Checkout = ({ onBackClick, presentedOfferCodes, selectedOffer }: CheckoutProps) => {
  const {
    user: { stripeCustomerId },
  } = useSubscribeForm();
  return (
    <div className="px-16 pb-80 pt-56 sm:px-28 sm:pb-96 md:pt-72 lg:pb-112">
      <div className="m-auto max-w-full md:max-w-[790px]">
        <SelectedSubscription selectedOffer={selectedOffer} />
        <Button variant="link" onClick={onBackClick} className="mb-48 flex items-center sm:mb-32">
          <IconArrow className="w-[17px] text-black" />
          <span className="ml-8 font-sans text-button-sm text-black">Back</span>
        </Button>
        {stripeCustomerId && (
          <PaymentForm
            buttonText="Subscribe"
            presentedOfferCodes={presentedOfferCodes}
            selectedOffer={selectedOffer}
            stripeCustomerId={stripeCustomerId}
          />
        )}
      </div>
    </div>
  );
};

export default Checkout;
